// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification[data-v-7c1c22ef] {\n    border-radius: 4px;\n    margin-top: 24px;\n    padding: 16px;\n}\n.notification--negative[data-v-7c1c22ef] {\n    background-color: var(--color-pinky-red-10);\n}\n.notification--positive[data-v-7c1c22ef] {\n    background-color: var(--color-light-sage-40);\n}\n.notification__center[data-v-7c1c22ef] {\n    max-width: 700px;\n    margin: 0 auto;\n}\n.notification__content[data-v-7c1c22ef] {\n    margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
